import logo from '@assets/givzgreen.svg';
import { Stack, styled } from '@mui/material';
import { FunctionComponent } from 'react';

const StyledLogo = styled('img')`
  height: 40px;
  margin-bottom: 40px;
`;

export const BrandHeader: FunctionComponent = () => {
  return (
    <Stack direction="column" spacing={1} alignItems="start" alignSelf="start">
      <StyledLogo src={logo} />
    </Stack>
  );
};
